<template lang="pug">
//- #navbar
//-   nav.navbar.navbar-expand-lg.navbar-light
//-     a.navbar-brand(href="#")
//-       img.navbar-img(src="/assets/ceav.svg")
//-       //span.navbar-text &nbspMemorial disperso
//-     button.navbar-toggler(type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation") 
//-       span.navbar-toggler-icon
//-     .collapse.navbar-collapse(id="navbarNav")
//-       .navbar-nav
//-         a.nav-item.nav-link.option.uppercase( v-for="option in menu" ref="#") {{option.option}}
#navbar
  b-navbar.navbar(toggleable="" type="dark" fixed="top" :class="{ 'nav-change': changeNavbar }")
    b-navbar-brand
        img.navbar-img(v-if="!changeNavbar" src="/assets/ceav.svg")
        img.navbar-img(v-if="changeNavbar" src="/assets/mvdf.svg")
    b-nav-text.uppercase.bold.nav-text(v-if="changeNavbar") Memorial Disperso
    b-navbar-toggle(target="nav-collapse")
    b-collapse(id="nav-collapse" is-nav)
        b-navbar-nav(class="ml-auto")
            b-nav-item.nav-item.option.uppercase.bold( v-for="(option, index) in menu" :href="'#section' + (index + 1)") 
              p.mb-0( v-html="option.option")
                

</template>

<script>
export default {
  name: "navbar",
  data() {
    return {
      changeNavbar: false,
      menu: [
        {
          option: "Introducción"
        },
        {
          option: "Memorial <br> Disperso"
        },
        {
          option: "Comparte <br> tu Memoria"
        },
        {
          option: "¿Cómo funciona?"
        }
      ]
    }
  },
  methods: {
    onScroll() {
      if (document.body.scrollTop > 600 || document.documentElement.scrollTop > 600) {
        this.changeNavbar = true;
      } else {
        this.changeNavbar = false;
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>

<style lang="scss">
  #navbar {
    //display: none;
    background-color: transparent;
    .nav-text {
      font-size: 1rem;
      color: #fff;
    }
    .nav-change {
      background-color: #285c4d;
    }
    .navbar-img {
      height: 5vh;
      max-width: 100%;
    }
    .option {
      color: #13322b;
    }
    .navbar-dark .navbar-nav .nav-link {
      color: #13322b;
      background-color: #fff;
      border-bottom: 1px solid #13322b;
      font-size: .8rem;
    }
    .navbar-dark .navbar-toggler {
      color: #fff;
      border: none;
    }
    .nav-item {
        a {
            padding: 1rem 0;
            line-height: 1;
            text-align: center;
        }
    }

  }
  @media (max-width: 767px) { 
    #navbar {
      .navbar-img {
        height: auto;
        max-width: 100%;
      }
    }
  }

</style>